import { useEffect, useState } from 'react'

const defaultHeaderUrl = 'https://efm-tktlogsso-cdnp-a.azureedge.net/header-v2'
const ContaEdenredHeader = () => {
    const [url] = useState(process.env.REACT_APP_HEADER_SOLUTION_LIB || defaultHeaderUrl)

    const handleScriptLoad = () => {
        const accessToken = localStorage.getItem("access_token")
        const apiUrl = `${process.env.REACT_APP_AUTH_URL}/api/User/*/getEdenredContaToken`
        const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${accessToken}` }
        
        fetch(apiUrl, { method: "GET", headers })
		.then(response => {
			if (!response.ok)
				console.error("Error al iniciar el componente SSO:");

			const r = response.json()
            //console.log(response, 'handleScriptLoad 1', r)
			return r;
		})
		.then(data => {
            //console.log(data, 'handleScriptLoad 2')
			if (!!data.token && !window['headerLoaded']) {
                window['headerLoaded'] = true
                window['FleetMobilityHeader'].ini({ shell: "div-shell-header-sso", token: () => data.token })
            }
		})
		.catch(error => {
			console.error("Error al iniciar el componente SSO:", error);
		})
    }

    const handleScriptError = () => {
        console.log('Error al cargar plugin de conta edenred')
    }

    useEffect(() => {
        const a = document.createElement('link')
        a.type = 'text/css'
        a.rel = 'stylesheet'
        a.href = `${url}/fm-header.min.css`
        document.head.appendChild(a)

        const b = document.createElement('script')
        b.src = `${url}/fm-header.min.js`
        b.async = true
        b.onload = handleScriptLoad
        b.onerror = handleScriptError

        document.head.appendChild(b)

        return () => {
            document.head.removeChild(a)
            document.head.removeChild(b)
        }
    }, [])

    return null
}

export default ContaEdenredHeader